if ("serviceWorker" in navigator && document.querySelector(".hitl-masthead")) {
  let hasController = Boolean(navigator.serviceWorker.controller)

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js")
      .then((registration) => {
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing
          if (!newWorker) return

          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent("hitl:update-available"))
            }
          })
        })
      })
      .catch((error) => console.warn("SW registration failed:", error))
  })

  let reloading = false
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hasController) {
      hasController = true
      return
    }

    if (reloading) return

    reloading = true
    window.location.reload()
  })

  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data?.type === "hitl:fetch-failed") window.dispatchEvent(new Event("hitl:fetch-failed"))
    if (event.data?.type === "hitl:fetch-succeeded") window.dispatchEvent(new Event("hitl:fetch-succeeded"))
  })
}
